import TerraKit from '@terra-js/terra-kit';

const isBrowserShareAvailable = () => {
  return typeof navigator !== "undefined" && !!navigator.share;
};
const isTerraShareAvailable = () => TerraKit.isAvailable();
let isSharing = false;
const share = async (title, text, url) => {
  const isTerraShare = isTerraShareAvailable();
  const isBrowserShare = isBrowserShareAvailable();
  try {
    if (!isTerraShare && !isBrowserShare || isSharing) {
      return;
    }
    isSharing = true;
    if (isTerraShare) {
      await TerraKit.share({ title, text, url });
    } else {
      await navigator.share({ title, text, url });
    }
  } catch (e) {
  } finally {
    isSharing = false;
  }
};

export { isBrowserShareAvailable, isTerraShareAvailable, share };
